export default class extends Controller {
  connect() {
    App.Helpers.addAjaxSuccessHandler(this.element, () => location.reload());
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/update-after-success-link-controller.js